import services from "@src/Services";
import {
  CheckTypeWrapper,
  HeaderSubTitle,
  HeaderTitle,
  TipWrapper,
} from "./style";
import { CHECK_TYPE_COLOR } from "../../Notification/NotificationList/NotificationCard/helper";
import { CHECK_TYPE } from "../../Notification/helper";

export const getCustomExtraPathSingleCheck = (
  propertyShortName: string,
  date: string,
  notificationId: string
) => {
  let path = `?property_short_name=${propertyShortName}&date=${date}`;

  if (notificationId) {
    path += `&notification_id=${notificationId}`;
  }

  return path;
};

export const getSingleCheckDisplay = async (
  propertyShortName: string,
  checkNumber: string,
  date: string,
  notificationId: string
) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathSingleCheck(
      propertyShortName,
      date,
      notificationId
    );

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/checks/${checkNumber}${customPath}`);

    if (!res.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};

export const CHECK_TYPE_VALUE: CheckTitleType = {
  "1": "Discount",
  "2": "Voided",
  "3": "Charge Tip",
};

const colorizeText = ({
  line,
  index,
  notificationType,
}: {
  line: string;
  index: number;
  notificationType: string;
}) => {
  if (
    line.includes(CHECK_TYPE_VALUE[CHECK_TYPE.DISCOUNT]) &&
    notificationType?.includes(CHECK_TYPE.DISCOUNT)
  ) {
    return (
      <TipWrapper color={CHECK_TYPE_COLOR[CHECK_TYPE.DISCOUNT]}>
        {line}
      </TipWrapper>
    );
  }

  if (
    line.includes(CHECK_TYPE_VALUE[CHECK_TYPE.TIP]) &&
    notificationType?.includes(CHECK_TYPE.TIP)
  ) {
    return (
      <TipWrapper color={CHECK_TYPE_COLOR[CHECK_TYPE.TIP]}>{line}</TipWrapper>
    );
  }

  if (
    line.includes(CHECK_TYPE_VALUE[CHECK_TYPE.VOID]) &&
    notificationType?.includes(CHECK_TYPE.VOID)
  ) {
    return (
      <TipWrapper color={CHECK_TYPE_COLOR[CHECK_TYPE.VOID]}>{line}</TipWrapper>
    );
  }

  if (index === 0) {
    return <HeaderTitle>{line}</HeaderTitle>;
  }
  if (line.includes("CHK")) {
    return <HeaderSubTitle>{line}</HeaderSubTitle>;
  }
  if (line.includes("Check Closed")) {
    return <CheckTypeWrapper>{line}</CheckTypeWrapper>;
  }
  return line;
};

export const getMappedSingleCheckData = (response: SingleCheckDataType[]) => {
  const data = response?.map((e: SingleCheckDataType) => {
    const notificationType = e?.notification_type;
    const checkString = e?.check_image
      ?.split("\r\n")
      ?.map((line: string, index: number) => {
        return (
          <>
            {colorizeText({ line, index, notificationType })}
            {"\n"}
          </>
        );
      });
    return checkString;
  });

  return data;
};
